export const DEFAULT_RULE_LIMIT = 0;

// Form validation constants
export const RULE_NAME_MAX_LENGTH = 150;

// Rule types
export const RULE_TYPES = {
  STARRED: 'starred',
  ASSIGNMENT: 'assignment',
};

// Action types
export const ACTION_TYPES = {
  STARRED: 'starred',
  ASSIGNMENT: 'assignment',
  XML: 'xml',
};

// Operation type mappings (single source of truth + derived inverse)
export const OPERATION_TYPE_ID_MAP = { sale: 1, rent: 2, temporary_rent: 3 };
export const OPERATION_ID_TO_KEY = Object.fromEntries(
  Object.entries(OPERATION_TYPE_ID_MAP).map(([key, id]) => [String(id), key])
);

// Portal specific groups
export const MELI_PORTAL_IDS = [1, 21, 3, 22, 10];

// Form steps
export const FORM_STEPS = {
  NAME: 1,
  CRITERIA: 2,
  ACTIONS: 3,
};

// Criterion types
export const CRITERION_TYPES = {
  PROPERTY_TYPE: 'propertyType',
  DEVELOPMENT_TYPE: 'developmentType',
  ATTRIBUTES: 'attributes',
  OPERATION_TYPES: 'operationTypes',
  PRICE: 'price',
  LOCATION: 'location',
  TAGS: 'tags',
};

// Assignment rule internal names (backend identifiers)
export const ASSIGNMENT_RULE_INTERNAL_NAMES = {
  OUT_OF_OFFICE: 'out_of_office_rule',
};
